module.exports = __webpack_public_path__ + "static/fachada_1-bb5f0daf937a3a891f6024461672aab6.jpg";